<template>
	<div :contenteditable="false" class="main">
        <autocomplete
            :style="'display:inline-block; width:' + (length * 12) + 'px'"
            ref="columnFilter"
            :search="search"
			:defaultValue="value"
            @change="
                (evt) => (change(evt.target.value))
            ">
        </autocomplete>
        <b-button @click="del" variant="link"><i class="fas fa-trash"></i></b-button>
	</div>
</template>

<script>
	import Autocomplete from "@trevoreyre/autocomplete-vue";

    export default {
		components: {
            autocomplete: Autocomplete
		},
        props: {
            columns: {
                default: () => []
            },
            value: {
                default: ""
            },
            id: {}
        },
		data() {
			return {
                length: this.value.length > 5 ? this.value.length : 5,
                data: ""
            }
        },
        methods: {
            change(data)
            {
                this.data = data; 
                data.length > 5 ? this.length = data.length : this.length = 5;
            },
			search(input) {
				//console.log(input)
				if (input.length < 1) {
					// this.tabulator_options.columns = this.initialColumns;
					return [];
				}

				let filteredCols = this.columns.filter((col) => {
					return (
						col.toLowerCase().indexOf(input.toLowerCase()) >
						-1
					);
                });
                
				filteredCols = filteredCols.map((col) => {
					return col;
				});

				return filteredCols;
            },
            del()
            {
                this.$emit("del", this.id)
                this.$destroy();
                this.$el.parentNode.removeChild(this.$el);
            },
            save()
            {
                return '${data["' + this.data + '"]}';
            },
            load()
            {

            }
        },
		mounted: async function () {
            //console.log("mounted")
            this.$emit("mounted", this, this.id);
            this.data = this.value;
        }
    }
</script>

<style scoped>
::v-deep .autocomplete-input
{
	padding-top: 6px;
	padding-bottom: 6px;
	padding-left: 6px;
	background-color: lightgray !important;
	background-image: revert;
	font-size: 1em;
    border: 0px
}
::v-deep .autocomplete-result-list
{
    width: 300px !important;
}
.main
{
	background-color: lightgray !important;
    border: 1px solid #eee;
    border-radius: 8px;
}
</style>
